import { usePlanSpaceDetailContext } from '../plan';
import { ReadyPlanGroup } from './CurrentPlanActive';
export const CurrentReady = () => {
  const {
    readySpacePlans,
    space
  } = usePlanSpaceDetailContext();
  return <ReadyPlanGroup readySpacePlans={readySpacePlans} countryCode={space?.countryCode} data-sentry-element="ReadyPlanGroup" data-sentry-component="CurrentReady" data-sentry-source-file="CurrentPlanReady.tsx" />;
};